const servicesData = [
  {
    id: "government-portal-development",
    title: "Government Portal Development",
    description:
      "Custom portals for citizen services, internal operations and department management.",
    dropdownDescription:
      "Secure, scalable portals for government and public services",
    path: "/services#government-portal-development",
    items: [
      "Citizen Service Portals",
      "Departmental Portals",
      "Online Applications & Approvals",
      "Secure & Compliant Systems",
    ],
  },
  {
    id: "whatsapp-automation",
    title: "WhatsApp Automation",
    description:
      "Automate customer communication, alerts, reminders and business workflows.",
    dropdownDescription:
      "Automate conversations, alerts and workflows on WhatsApp",
    path: "/services#whatsapp-automation",
    items: [
      "Auto Replies & Chatbots",
      "Lead Capture & Management",
      "Alerts & Notifications",
      "Integration with CRM/Systems",
    ],
  },
  {
    id: "mis-dashboards",
    title: "MIS & Dashboards",
    description:
      "Real-time dashboards and MIS solutions for better visibility and decision-making.",
    dropdownDescription:
      "Real-time dashboards and management information systems",
    path: "/services#mis-dashboards",
    items: [
      "Real-time Reporting",
      "Custom Dashboards",
      "Data Visualization",
      "Role-based Access",
    ],
  },
  {
    id: "workflow-automation",
    title: "Workflow Automation",
    description:
      "Automate repetitive processes, approvals and assignments to save time and cost.",
    dropdownDescription:
      "Automate business processes and approvals with ease",
    path: "/services#workflow-automation",
    items: [
      "Process Automation",
      "Approval Workflows",
      "Task Management",
      "Audit Trails & Logs",
    ],
  },
  {
    id: "ai-intelligent-automation",
    title: "AI & Intelligent Automation",
    description:
      "Leverage AI and intelligent tools to automate tasks and improve operational efficiency.",
    dropdownDescription: "AI-powered solutions for smarter operations",
    path: "/services#ai-intelligent-automation",
    items: [
      "AI Chatbots & Assistants",
      "Document Processing (OCR)",
      "Predictive Insights",
      "Smart Automation",
    ],
  },
  {
    id: "global-software-services",
    title: "Global Software Services",
    description:
      "Custom software development for businesses and agencies across the globe.",
    dropdownDescription:
      "Custom software development for global businesses",
    path: "/global-software-services",
    items: [
      "Web & Mobile Applications",
      "SaaS Development",
      "API & System Integrations",
      "Maintenance & Support",
    ],
  },
];

export default servicesData;
